import { get, isEqual, pick } from 'lodash/fp';
import { createSelector } from 'reselect';
import { COMPLETED } from '../../../../../constants/reservation/Status';

export const getReservationView = get('reservation.routes.view');

export const getViewReservationData = createSelector(
  getReservationView,
  get('data')
);

export const getViewReservationGuestInfo = createSelector(
  getViewReservationData,
  pick(['firstName', 'lastName', 'guestId', 'householdTotal', 'homeless'])
);

export const getHasLinkedOrderItems = createSelector(
  getReservationView,
  get('hasLinkedOrderItems')
);

export const getResevationStatus = createSelector(
  getViewReservationData,
  get('status')
);

export const getIsResevationCompleted = createSelector(
  getResevationStatus,
  isEqual(COMPLETED)
);

export const getIsFetching = createSelector(
  getReservationView,
  get('fetching')
);

export const getIsFetched = createSelector(getReservationView, get('fetched'));

export const getIsSaving = createSelector(getReservationView, get('saving'));

export const getISaved = createSelector(getReservationView, get('saved'));
